import React, { useState } from 'react';
import bemCn from 'bem-cn';
import loadable from '@loadable/component';
import { mainMenu } from './consts';
import CookieService from '../../services/cookie.service';
import { SIGN_UP_SRC } from '../../consts/profile.const';
import { RouteFormatter } from '../../routes';
import { savePathRedirect } from '../../helpers/cookies';
import { COOKIE_PARAM_NAME } from '../../consts/cookies.consts';
import { RenderBlogs, RenderDogBreeds, RenderDogNames, RenderDogRescues, RenderSubParks, RenderTrainers } from './shared';
import SniffButton from '../sniff-button';
import SvgSnifLogo from 'src/assets/svg/SvgSnifLogo.svg';
import './style.scss';

const BlurSignupModal = loadable(() => import('../modal-blur-signup'));

const b = bemCn('nav-guest-unauth');

const NavigationGuestUnauth = () => {
    const [isBlurTest, setIsBlurTest] = useState(false);

    const onClick = async (e, type) => {
        e.preventDefault();

        savePathRedirect();
        CookieService.set(COOKIE_PARAM_NAME.SIGN_UP_FROM, SIGN_UP_SRC.NAV_WEB, { expires: 1 });

        if (type === 'signUp') {
            setIsBlurTest(true);
        } else {
            window.location = RouteFormatter.signIn();
        }
    };

    return (
        <header className={b.mix('d-none d-md-flex')}>
            <div className={b('left')}>
                <a href={RouteFormatter.home()} className={b('logo')}>
                    <SvgSnifLogo />
                </a>
                {mainMenu.map((v, i) => (
                    <div key={i} className={b('main-menu').mix(`snif-p ${v.id}`)}>
                        <a href={v.url}>{v.name}</a>
                        {v.id === 'DP' && <RenderSubParks />}
                        {v.id === 'BG' && <RenderBlogs />}
                        {v.id === 'DN' && <RenderDogNames />}
                        {v.id === 'DR' && <RenderDogRescues />}
                        {v.id === 'TR' && <RenderTrainers />}
                        {v.id === 'DB' && <RenderDogBreeds />}
                    </div>
                ))}
            </div>
            <div className={b('right')}>
                <a href={RouteFormatter.signIn()} onClick={(e) => onClick(e, 'signIn')}>
                    <SniffButton style={{ border: 'none' }} color="secondary">
                        Sign in
                    </SniffButton>
                </a>
                <a href={RouteFormatter.signUp()} onClick={(e) => onClick(e, 'signUp')}>
                    <SniffButton>Sign up</SniffButton>
                </a>
            </div>
            <BlurSignupModal {...{ isBlurTest, setIsBlurTest, useStateSSR: useState }} />
        </header>
    );
};

export default NavigationGuestUnauth;
